import React, { Component } from "react";

import { Button, Popconfirm } from 'antd';

import NotaOperativaUpload from "../../../assets/Linee_guida_allegati.pdf";

import Wrapper from "@common/decorators/Wrapper";

import moment from 'moment';

import checkAutodichiarazione from '@common/utils/check/autodichiarazione';
import GestioneLR from '../../gestioneLR/services/GestioneLR'

@Wrapper({
  route: "Dashboard",
  hasSidebar: true,
  hasHeader: true,
  hasFooter: true,
  public: true,
})
class Dashboard extends Component {

  state = {
    loading: false,
  };
  
  terminiContent={
    heading:"Accettando i termini l’interessato, nella sua qualità di legale rappresentante dell’operatore, consapevole delle responsabilità e delle conseguenze derivanti in caso di false dichiarazioni, così come dettate anche dalle Linee guida per l’accreditamento, ai sensi del DPR 28 dicembre 2000, n. 445 smi, dichiara:",
    contentList:[
      "di confermare la veridicità di tutte le informazioni e i documenti forniti dall’operatore nell’ambito della Piattaforma informativa dedicata, attestanti il possesso dei requisiti che lo stesso operatore è tenuto a possedere ai fini dell’accreditamento",
      "di confermare tutto quanto ulteriormente descritto nell’ambito della Piattaforma informativa dedicata circa l’iscrizione nelle specifiche sezioni dell'elenco regionale dei soggetti pubblici e privati accreditati",
      "di conoscere e di attenersi agli obblighi degli operatori previsti dalle Linee guida per l’accreditamento."
      ]
  }

  accettaTermini() {
    this.setState({loading: true});
    GestioneLR.accetta({'id_ente': this.props.UserStore.user.ente.id},
      res => {
        this.setState({ loading: false });
        //let storicoRL = res.data.data;
        window.location.reload();
      },
      (e) => {
          this.setState({ loading: false });
      })
  }

  render() {

    return (
      <div>
        <h2 style={{ color: '#444' }}>SILF - Accreditamento</h2>
        <h3>
          Sistema Accreditamento organismi che erogano servizi di istruzione e
          formazione e servizi per il lavoro
        </h3>

        <br></br>

        { !checkAutodichiarazione.resa(this.props) ?
          <div>
            <hr/>
            <br/>
              <b>Attenzione!</b> in data {moment(this.props.UserStore.user.ente.storicoRL.data_inizio_validita).format("DD/MM/YYYY")}
              
              &nbsp;
              sei stato nominato sul Sistema di Accreditamento come Rappresentante Legale dell'Ente <b>
                {this.props.UserStore.user.ente.denominazione}</b>.
              <br/>
              <br/>
              Per poter proseguire è necessario accettare i seguenti termini.
              <br/>
              <br/>
              <br/>
              {/* <i>da definire...</i> */}
              <p>{this.terminiContent.heading}</p>
              <ul>
                {this.terminiContent.contentList.map(term=>(<li>
                  {term}
                
                </li>))}

              </ul>
              <br/>
              <br/>
              <Popconfirm placement="top" title="Sei sicuro di voler accettare i termini descritti?"
                onConfirm={() => {
                  this.accettaTermini()
                }}
                okText="Si" cancelText="No">
                <Button
                  loading={this.state.loading}
                  className="m5h" type="primary" icon="check"
                  style={{ marginRight: 8 }}>Accetto i termini sopra descritti</Button>
              </Popconfirm>
              <br/>
              <br/>
            <hr/>
          </div>
          :
          null
        }

        <br></br>

        <h4>
        <a target={"_blank"} href={NotaOperativaUpload} >Note operative per il caricamento di allegati</a>
        </h4>
        
        <br></br>

        <h4>
          Si comunica che con DGR n. 270 del 30-5-2024 sono stati prorogati al 31-7.2024 i termini per il completamento della presentazione della domanda di accreditamento sulla nuova piattaforma, di cui alla DGR 136/2022 e alla nota prot. N. 37175 del 22/01/2024.
        </h4>

        {/* <DashboardLayout /> */}
        {/* {this.returnComponent()} */}
      </div>
    );
  }
}

export default Dashboard;
